export default "__VITE_ASSET__Drnh43_K__"